import styled from 'styled-components';
import { cssVar } from 'src/app/styles/helper';

export const FieldLabelContainer = styled.label`
  font-family: ${cssVar('font-family-body')};
  font-size: ${cssVar('font-size-text-sm')};
  font-weight: ${cssVar('font-weight-medium')};
  line-height: ${cssVar('line-height-text-sm')};
  color: ${cssVar('text-secondary')};
  display: block;

  span {
    color: ${cssVar('text-brand-tertiary')};
    margin-left: ${cssVar('spacing-xxs')};
  }
`;
